import React from 'react';
import Marquee from 'react-fast-marquee';
interface MarqueeProps {
  speed?: number;
  stopOnHover?: boolean;
  stopOnClick?: boolean;
  gradient?: boolean;
  direction?: 'left' | 'right';
}

export const MarqueeSlider: React.FC<MarqueeProps> = ({ children, ...props }) => {
  const { speed, direction, stopOnHover, gradient, stopOnClick } = props;

  return (
    <Marquee
      pauseOnHover={stopOnHover}
      pauseOnClick={stopOnClick}
      direction={direction}
      gradient={gradient}
      speed={speed}
    >
      {children}
    </Marquee>
  );
};
